import { Dialog, Switch, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";

import { IRotaManagementShiftListData } from "@/api_framework/api_modals/Rota";
import { useRotaShiftListAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftListAPI";
import { useRotaShiftStatsAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftStatsAPI";
import { useRotaShiftUpdateAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftUpdateAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IRotaState } from "@/app_redux/reducers/slices/auth/rota_slice";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { IRotaActiveDeactiveModal } from "../../interface";

const ShiftActiveDeactiveModalComponent: React.FC<IRotaActiveDeactiveModal> = (props) => {
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [openFlage, setOpenFlage] = useState(props?.flage);

  const shiftUpdateAPI = useRotaShiftUpdateAPI();
  const fetchShiftListAPI = useRotaShiftListAPI();
  const fetchStatsListAPI = useRotaShiftStatsAPI();

  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ROTA", "id");

  const { routeState } = useRouteInfo(routeId);
  const { shiftList } = routeState.state as IRotaState;

  const foundShift = shiftList?.find((shift) => shift.id === props?.shift_id);

  const handelClick = () => {
    // if (foundShift?.shift_status) {
    //   setOpenFlage(true);
    // } else {
    //   setOpenFlage(false);
    // }

    const constructedBody: IRotaManagementShiftListData = {
      shift_name: foundShift?.shift_name,
      shift_timings: foundShift?.shift_timings,
      shift_status: foundShift?.shift_status ? false : true,
    };
    shiftUpdateAPI(constructedBody, props?.shift_id).then(() => {
      fetchShiftListAPI(foundShift?.shift_status);
      fetchStatsListAPI();
      setOpen(false);
    });
  };

  const handelToggle = () => {
    setOpen(false);
    setOpenFlage(props?.flage);
  };

  useEffect(() => {
    setOpenFlage(props?.flage);
  }, [props?.flage]);

  return (
    <div>
      <div className="">
        <Switch
          checked={openFlage}
          onChange={() => {
            setOpen(!open);
          }}
          className={`${openFlage ? "bg-indigo-600" : "bg-gray-200"}
          relative inline-flex h-7 w-16 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white/75`}
        >
          <span
            aria-hidden="true"
            className={`${openFlage ? "translate-x-9" : "translate-x-0"}
            pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
          />
        </Switch>
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block  align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <span className="flex justify-end ml-6 cursor-pointer" onClick={() => setOpen(false)}>
                    <XMarkIcon className="h-5 w-5" />
                  </span>
                  <h3 className="text-sm text-[#000] font-medium mb-1 flex justify-between">
                    {`Are you sure you want to ${props?.flage ? "deactivate" : "activate"} this schedule ?`}
                  </h3>
                  <div className="flex gap-4 mt-6 justify-end">
                    <button
                      type="button"
                      onClick={() => handelToggle()}
                      className="text-xs mt-3 inline-flex w-full justify-center rounded-md bg-[#808DA0] px-4 py-2 font-semibold text-white   ring-inset ring-gray-300 hover-bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      No
                    </button>
                    <button
                      type="button"
                      onClick={() => handelClick()}
                      className="text-xs mt-3 inline-flex w-full justify-center rounded-md bg-[#193A6A] px-4 py-2 font-semibold text-white   ring-inset ring-gray-300 hover-bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default ShiftActiveDeactiveModalComponent;
